module.exports = __webpack_public_path__ + "img/empty-cart.127fd172.svg";